<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6 col-lg-4">
        <div class="card shadow-sm">
          <div class="card-body">
            <h2 class="card-title text-center mb-4">Login</h2>
            <form @submit.prevent="submitLogin">
              <div class="mb-3">
                <label for="username" class="form-label">Username:</label>
                <input type="text" id="username" v-model="username" class="form-control" required :disabled="loading" />
              </div>
              <div class="mb-3">
                <label for="password" class="form-label">Password:</label>
                <input type="password" id="password" v-model="password" class="form-control" required :disabled="loading" />
              </div>
              <button type="submit" class="btn btn-primary w-100" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {{ loading ? 'Logging in...' : 'Login' }}
              </button>
            </form>
            <p v-if="error" class="text-danger text-center mt-3">{{ error }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, inject } from 'vue';

export default {
  name: 'UserLogin',
  setup() {
    const username = ref('');
    const password = ref('');
    const error = ref(null);
    const loading = ref(false); // Add loading state
    const login = inject('login'); // Injected login function from App.vue (which calls auth.js login)

    const submitLogin = async () => {
      loading.value = true; // Set loading to true when starting the request
      error.value = null; // Clear previous errors
      try {
        // Directly call the injected login function from auth.js
        const success = await login(username.value, password.value);
        if (!success) {
          error.value = 'Login failed. Please check your credentials.';
        }
      } catch (err) {
        error.value = err.message || 'An error occurred during login.';
        console.error(err);
      } finally {
        loading.value = false; // Set loading to false when the request is complete
      }
    };

    return {
      username,
      password,
      error,
      loading, // Expose loading state
      submitLogin,
    };
  },
};
</script>

<style scoped>
/* Add any specific styles for the login page here if needed */
</style>
